import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';

import { useTransl } from 'shared/lib/i18n';

import CommunityMessageSellerFormComponent from './CommunityMessageSellerFormComponent';

import { onModalClose } from '../../Modal/actions';
import { createMessageSeller } from '../actions';

const form = 'communityMessageSeller';

const CommunityMessageSellerFormContainer = (props) => {
  const { t } = useTransl();
  const { postId, subject, onCreateMessage, onModalClose, formValues } = props;

  const initialValues = {
    subject: t('metaInfo.reSubject', { subject }),
  };

  const onMessageSubmit = () => {
    onModalClose();
    return onCreateMessage(
      Object.assign(formValues, {
        post: postId,
      }),
    );
  };

  return (
    <CommunityMessageSellerFormComponent
      form={form}
      onModalClose={onModalClose}
      onMessageSubmit={onMessageSubmit}
      initialValues={initialValues}
    />
  );
};

CommunityMessageSellerFormContainer.propTypes = {
  onCreateMessage: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Object).isRequired,
  postId: PropTypes.number.isRequired,
  subject: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  formValues: getFormValues(form)(state) || {},
});

const mapDispatchToProps = (dispatch) => ({
  onCreateMessage: (data) => createMessageSeller(dispatch, data),
  onModalClose: () => onModalClose(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityMessageSellerFormContainer);
